module.exports = __webpack_public_path__ + "static/img/shopRegister.fe73baf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shopRegister.png
// module id = 3140
// module chunks = 1